export default __webpack_public_path__ + "static/media/ignis.fc611c61.jpg";